module.exports = __webpack_public_path__ + "static/media/back.227956f1.svg";